<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Ballet and Dance
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Ballet and Dance</strong> generated $69.6m in revenue and attracted close to 0.7m attendances.</p>
          <p><strong>Ballet and Dance</strong> recorded a y-o-y decline in revenue of 4.7% (from $73.0m in 2024 to $69.6m in 2025) and a y-o-y decline in attendance of 3.4% (from 0.72m in 2024 to 0.70m in 2025). Average ticket prices also declined by 3.2% y-o-y (from $112.80 in 2024 to $109.17 in 2025), which contributed to the decrease in revenue.</p>
          <p>Revenue in <strong>Ballet and Dance</strong> was primarily driven by major performances such as <em>The Sleeping Beauty</em>, <em>The Nutcracker</em>, <em>Manon</em>, <em>Nijinsky</em>, <em>Swan Lake</em>, <em>Carmen</em>, <em>Prism</em> and <em>Cinderella</em>.</p>
          <p>In 2025, 63.7% of revenue and 59.2% of attendance in <strong>Ballet and Dance</strong> were generated through performances by NPAP companies, such as The Australian Ballet, Sydney Dance Company, Bangarra Dance Theatre, Queensland Ballet and West Australian Ballet. NPAP Ballet and Dance companies recorded a decline in revenue by 3.0% and an increase in attendance by 1.3% in 2025 compared to 2024.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, NSW and VIC generated the most revenue and attendance in this category. NSW and VIC held a national market share and together generated 62.9% of national <strong>Ballet and Dance</strong> revenue and 57.3% attendance in 2025.</p>
          <p>The overall decline in this category in 2025 was primarily driven by weaker results in NSW, which recorded a y-o-y decline of 16.1% in revenue and 19.5% in attendance. The decline was partially offset by y-o-y growth in both revenue and attendance across VIC, QLD, SA and ACT. All other states and territories recorded a decline in both revenue and attendance.</p>
          <p>ACT recorded the highest y-o-y growth in revenue (42.9%) and second-highest y-o-y growth in attendance (26.6%) in <strong>Ballet and Dance</strong>, driven by performances such as <em>Carmen</em>, <em>The Nutcracker</em>, <em>Dracula</em> and <em>Illume</em>. However, its impact is minimal as it represented only 3.0% in revenue and 2.8% in attendance of the overall market share in the <strong>Ballet and Dance</strong> category.</p>
          <p>SA recorded the second-highest y-o-y growth in revenue (35.1%) and the highest y-o-y growth in attendance (86.0%). The growth in revenue was driven by major performances including <em>The Sleeping Beauty</em>, <em>The Nutcracker</em> and <em>Romeo and Juliet</em>.</p>
          <p>QLD recorded the third-highest y-o-y growth in revenue (12.9%) and the fourth-highest y-o-y growth in attendance (7.6%). The growth in revenue was driven by performances such as <em>The Nutcracker</em>, <em>Swan Lake</em> and <em>The Sleeping Beauty</em>.</p>
        </div>

        <p style="font-size: .8em;text-align: center;">Note: Data for Dance performances that were presented as part of a multi-artform festival will be captured in <strong>Festivals (Multi-Category)</strong>.</p>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="ballet-dance-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/BALLET AND DANCE  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Ballet And Dance Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Illume</em>, Bangarra Dance Theatre, Photo Credit: Daniel Boud</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [30.664, 44.563, 52.524, 77.287, 47.052, 58.571, 57.509, 59.164, 57.866, 62.833, 52.772, 63.522, 60.08, 62.339, 63.989, 66.159, 7.535, 26.942, 63.344, 70.365, 73.023, 69.596],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.683, 0.931, 1.114, 1.457, 0.935, 1.051, 1.023, 0.948, 0.92, 0.976, 0.768, 0.859, 0.815, 0.81, 0.801, 0.803, 0.137, 0.364, 0.74, 0.808, 0.724, 0.699],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 38.5],
            ["VIC", 24.4],
            ["QLD", 19.8],
            ["WA", 8.5],
            ["SA", 4.8],
            ["ACT", 3.0],
            ["TAS", 0.6],
            ["NT", 0.3],
          ],
          attendance: [
            ["NSW", 32.4],
            ["VIC", 24.8],
            ["QLD", 20.4],
            ["WA", 11.2],
            ["SA", 6.6],
            ["ACT", 2.8],
            ["TAS", 0.9],
            ["NT", 0.9],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/18-Ballet-+-Dance-Illume---Bangarra_credit_Daniel-Boud_164.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
